import { colorError, colorSuccess } from "@porsche-design-system/components-react/emotion"
import { VehicleStatus } from "@slfinrtl/ui-bff-routes"

export const getStatusBadgeColor = (status: VehicleStatus): string => {
	switch (status) {
		case VehicleStatus.AVAILABLE:
			return colorSuccess
		case VehicleStatus.RESERVED:
		case VehicleStatus.ONLINE_ORDERED:
		case VehicleStatus.ONLINE_RESERVED:
			return "#4493F6"
		case VehicleStatus.SOLD:
		case VehicleStatus.DELIVERED:
		case VehicleStatus.REMOVED:
		case VehicleStatus.OPEN_CAMPAIGNS:
		case VehicleStatus.SOLD_LINK:
			return colorError
	}
}
